export default {
    en: {
        id: 'diagram4b2-4',
        blocks: [
            {
                index: '1',
                task: 'S = American prosperity said to be explained by new technology and enterprising attitudes',
                title: "S = "
            },
            {
                index: '2',
                task: 'C = In fact, had no particular edge over other industrial nations',
                title: "C = "
            },
            {
                index: '3',
                task: 'Q = Why did they prosper?',
                title: "Q = "
            }
        ],
        answers: [
            {
                index: '2',
                title: 'Not true'
            },
            {
                index: '3',
                title: 'How achieve X?'
            },
            {
                index: '1',
                title: 'Say achieved X because of Y'
            },
        ],
        title: 'Please drag the boxes with the correct algebraic structure into the right positions so that they match the SCQ statements provided.',
        correctAnswers: 3,
        note: 'This is another perfectly permissible form, where you state how things were historically, then state the usual explanation for things having been that way. The question then is whether the original insight is true or not. It is an extremely efficient way to educate a reader to current thinking on a subject while at the same time setting him up to be ready to hear why the thinking is wrong.'
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/4/4b2/spottingSCQ/i18n/exercise4.js